export function replacePattern(pattern, replacements) {
  return pattern
  // eslint-disable-next-line unicorn/prefer-spread -- there is a bug in babel https://github.com/babel/babel/issues/8298
  .split('').map(function (char) {
    var _replacements$char;
    return (_replacements$char = replacements[char]) !== null && _replacements$char !== void 0 ? _replacements$char : char;
  }).join('');
}